import { render, staticRenderFns } from "./WorkAddressForm.vue?vue&type=template&id=d2c83db4"
import script from "./WorkAddressForm.vue?vue&type=script&lang=js"
export * from "./WorkAddressForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports